module.exports = __webpack_public_path__ + "img/person.05075bf0.svg";